module.exports = __webpack_public_path__ + "static/img/hdzqt.f48dbc6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hdzqt.png
// module id = AnDg
// module chunks = 1